import Vue from 'vue';
import Router, { RouteConfig } from 'vue-router';

import Process from '../components/process/Process.vue';
import ProcessView from '../components/process/container/view/ProcessView.vue';
import ProcessReview from '../components/process/container/review/ProcessReview.vue';

Vue.use(Router);

const routes: RouteConfig[] = [
  {
    path: '/review',
    name: 'Review',
    component: ProcessReview,
  },
  {
    path: '/process',
    name: 'Process',
    component: Process,
    children: [
      {
        path: 'view',
        name: 'View',
        component: ProcessView,
        meta: { requiresAuth: true },
      },
    ],
    meta: { requiresAuth: true },
  },
  {
    path: '/',
    redirect: '/review',
  },
  {
    path: '*',
    redirect: '/review',
  },
];


export function createRouter(subdomain: string): Router {
  const router = new Router({
    mode: 'history',
    base: `/${subdomain}`,
    routes,
  });

  router.beforeEach(async (to: any, from: any, next: any) => {

    if (to.matched.some((record: any) => record.meta.requiresAuth) && !router.app.$api.isAuthenticated) {
        try {
          await router.app.$api.checkAuthentication();
          next();
        } catch {
          router.app.$api.login();
        }
    } else {
      next();
    }

  });

  return router;
}
